<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 myp" id="ليلى"><p style="text-indent:00em"><span dir="rtl">
</span></p>
<p style="text-indent:00em"><span dir="rtl">عزيزي القارئ..</span></p>
<br/>
<p style="text-indent:00em"><span dir="rtl">كن واثقًا وتقدَّم، سلِّم نفسك لقلمي، واخطُ بخطاك إلى عالمي، لأرسم حولك فقاعة بيضاء، يكون الدخول والخروج منها أمرًا صعبًا.</span></p>
<p style="text-indent:00em"><span dir="rtl">تقدَّم وامضِ معي بين الصفحات، حيث الغزل يقابل اللعنات، حيث الواقع يحتضن الخيالات، حيث تكون أنتَ جزءًا مِن مملكتي..</span></p>
<p style="text-indent:00em"><span dir="rtl">ومِن ممتلكاتي.</span></p>
<br/>
<p style="text-indent: 00em; text-align: left;"><strong><span dir="rtl">ليلى</span></strong></p>
<p style="text-indent:00em"><strong><span dir="rtl"><br/>
</span></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?1e3874dd